import {makeCall} from '../api.js';
import {isAuthenticated} from '../authHelpers.js';
import _ from 'lodash';

export const getCartCount = () => {
  return makeCall({
    method: 'GET',
    action: 'cart/getcartcount'
  });
};

/* server CRUD */

export const getCart = () => {
  if (isAuthenticated())
    return makeCall({
      method: 'GET',
      action: 'cart'
    });
  else
    return new Promise((res) => res(getCartFromLocaleStorage()));
};


export const updateCart = (cartDetail) => {
  if (isAuthenticated()){
    cartDetail.cartId = 0; // create new item for user
    return makeCall({
      method: 'POST',
      action: 'cart',
      body: JSON.stringify(cartDetail)
    });
  }

  else {
    let cartDetails = getCartFromLocaleStorage();
    if (cartDetails) {
      cartDetails = [...cartDetails, cartDetail];
      return new Promise((res) => res(setCartToLocaleStorage(cartDetails)));
    }
    else {
      return new Promise((res) => res(setCartToLocaleStorage([cartDetail])));
    }
  }
};

export const multipleCreateCart = (cartArray) => {
    return makeCall({
      method: 'POST',
      action: 'cart/carts',
      body: JSON.stringify(cartArray)
    });
};


export const deleteCartItem = (cartId, cartItems) => {
  if (isAuthenticated())
    return makeCall({
      method: 'DELETE',
      action: 'cart',
      body: JSON.stringify({cartId})
    });
  else {
    let cart = _.filter(cartItems, (el) => +el.cartId !== +cartId);
    return new Promise((res) => res(setCartToLocaleStorage(cart)));
  }
};



/* localStorage CRUD */

export function getCartFromLocaleStorage() {
  return JSON.parse(localStorage.getItem('cart'));
}

export function setCartToLocaleStorage(cart) {
  localStorage.setItem('cart', JSON.stringify(cart));
  return 'success';
}

export function removeCartFromLocaleStorage() {
  localStorage.removeItem('cart');
}


/* Cart helpers */
export function removeCartItemsFromState(actionCartDetailId, cartItems) {
  return _.filter(cartItems, (el) => +el.cartId !== +actionCartDetailId); // dynamic update view delete acyion
}

export const changeCartProperty = (propertyToChange, cartId, cartItems) => {
  let updatedCartDetails = _.filter(cartItems, (el) => +el.cartId === +cartId);
  let updatedCartDetail;
  if (propertyToChange.newQuantity) {
    updatedCartDetail = [{ ...updatedCartDetails[0], quantity: propertyToChange.newQuantity }];
  }
  else if (propertyToChange.text) {
    updatedCartDetail = [{ ...updatedCartDetails[0], comment: propertyToChange.text }];
  }

  if (isAuthenticated()) {
    return makeCall({
      method: 'POST',
      action: 'cart',
      body: JSON.stringify(updatedCartDetail[0])
    });
  }
  else {
    let index = _.indexOf(cartItems, _.find(cartItems, { cartId: cartId }));
    let resultCartItems = getCartFromLocaleStorage();
    resultCartItems.splice(index, 1, updatedCartDetail[0]);

    return new Promise(res => res(setCartToLocaleStorage(resultCartItems)) );
  }
};


export const checkout = (id) => {
  return makeCall({
    method: 'GET',
    action: `checkout?legalId=${id}`
  });
};



/** WEBPACK FOOTER **
 ** ./src/logic/api/cart.js
 **/